import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {toggleMap} from '../../actionCreators';

const Labels = {
    desktop: {
        [false]: gettext('location search in map'),
        [true]: gettext('back to table'),
    },
    mobile: {
        [false]: gettext('map'),
        [true]: gettext('table'),
    },
};

const Toggle = ({showMap, onClick}) => (
    <span className="struct-link-wrapper">
        <a className="struct-link" onClick={onClick}>
            {Object.keys(Labels).map(key => (
                <span key={key} className={`${key}-only`}>
                    {Labels[key][showMap]}
                </span>
            ))}
        </a>
    </span>
);

const mapStateToProps = ({showMap}) => ({showMap});

const mapDispatchToProps = (dispatch) => ({
    onClick: () => dispatch(toggleMap),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toggle);
